import Marquee from 'react-fast-marquee';

const ITEMS = [
  '22+ Years of Nebraska Craftsmanship',
  'Locally Owned & Operated',
  'A+ BBB Rating',
  'Licensed & Insured',
  'Custom Design · One Accountable Team',
  'Serving Omaha & Lincoln',
];

const EditorialMarquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y ${dark ? 'border-paper/10 bg-graphite py-6' : 'border-line bg-paper2/60 py-6'}`}
    aria-hidden="true"
  >
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-serif text-2xl italic md:text-3xl ${dark ? 'text-paper/40' : 'text-ink/35'}`}>
            {item}
          </span>
          <span className={`mx-10 inline-block h-1.5 w-1.5 rotate-45 ${dark ? 'bg-bronze/60' : 'bg-bronze/70'}`} />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
